var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0H24V24H0z",
    opacity: 0.01
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#90929C",
    fillRule: "evenodd",
    d: "M16.667 5.6h-.778v-.8c0-.442-.348-.8-.778-.8-.43 0-.778.358-.778.8v.8H9.667v-.8c0-.442-.349-.8-.778-.8-.43 0-.778.358-.778.8v.8h-.778C6.045 5.6 5 6.675 5 8v9.6C5 18.925 6.045 20 7.333 20h9.334C17.955 20 19 18.925 19 17.6V8c0-1.325-1.045-2.4-2.333-2.4zM8.889 16c-.43 0-.778-.358-.778-.8 0-.442.348-.8.778-.8.43 0 .778.358.778.8 0 .442-.349.8-.778.8zm6.222 0H12c-.43 0-.778-.358-.778-.8 0-.442.348-.8.778-.8h3.111c.43 0 .778.358.778.8 0 .442-.348.8-.778.8zm2.333-4.8H6.556V8c0-.442.348-.8.777-.8h.778V8c0 .442.348.8.778.8.43 0 .778-.358.778-.8v-.8h4.666V8c0 .442.349.8.778.8.43 0 .778-.358.778-.8v-.8h.778c.43 0 .777.358.777.8v3.2z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.dda6ebfe.svg";
export { ForwardRef as ReactComponent };